// removed by extract-text-webpack-plugin
module.exports = {"banner-wrapper":"banner-wrapper__2YLuc","banner":"banner__2J9N0","bottom-section":"bottom-section__24P6I","top-section":"top-section__1DNL4","light":"light__3dP6L","dark":"dark__AnvNV","image":"image__3TrO_","banner-elements":"banner-elements__3Cvqv","name":"name__3cAL6","variant":"variant__3yFWy","divider":"divider__25Iea","scroll-down":"scroll-down__3uJ8g","arrow":"arrow__3zneq"};


//////////////////
// WEBPACK FOOTER
// ./components/raffle/styles/RaffleBanner.scss
// module id = lsZm
// module chunks = 1